import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';

import SizeOptionRow from "./size-option-row";
import DefaultOptionRow from "./default-option-row";
import SectionalLayoutOptionRow from "./sectional-layout-option-row";
import FabricOptionRow from "./fabric-option-row";
import DaybedOrientationOptionRow from "./daybed-orientation-option-row";
import TextOptionRow from "./text-option-row";

export const OptionRow = props => {
  const { id, ...componentProps } = props;
  const { optionType, optionId, optionSelected } = props;
  const optionName = optionType.get("name");

  const handleClick = (optionValueId, e) => {
    if (e) {
      e.preventDefault();
    }

    optionSelected(optionId, optionValueId);
  };

  switch (optionName) {
    case "sofa_width":
    case "chair_height":
    case "daybed_width":
    case "bench_width":
      return (
        <div id={id} className="product-option-container">
          <SizeOptionRow {...componentProps} handleClick={handleClick} />
        </div>
      );

    case "bed_size":
    case "seat_cushion_fill":
    case "ottoman_width":
    case "height":
      return (
        <div id={id} className="product-option-container">
          <TextOptionRow {...componentProps} handleClick={handleClick} />
        </div>
      );

    case "bed_construction":
      return (
        <div id={id} className="product-option-container">
          <TextOptionRow
            {...componentProps}
            showOptionPrice
            handleClick={handleClick}
          />
        </div>
      );

    case "fabric":
      return (
        <div id={id} className="product-option-container">
          <FabricOptionRow {...componentProps} handleClick={handleClick} />
        </div>
      );

    case "daybed_orientation":
      return (
        <div id={id} className="product-option-container">
          <DaybedOrientationOptionRow {...componentProps} handleClick={handleClick} />
        </div>
      );

    case "sectional_layout":
      return (
        <div id={id} className="product-option-container">
          <SectionalLayoutOptionRow {...componentProps} handleClick={handleClick} />
        </div>
      );

    default:
      return (
        <div id={id} className="product-option-container">
          <DefaultOptionRow {...componentProps} handleClick={handleClick} />
        </div>
      );
  }
};

OptionRow.propTypes = {
  customValueChanged: PropTypes.func.isRequired,
  editComDetailField: PropTypes.func.isRequired,
  comDetail: PropTypes.object,
  optionType: ImmutablePropTypes.map.isRequired,
  optionId: PropTypes.string.isRequired,
  optionSelected: PropTypes.func.isRequired,
  optionValues: ImmutablePropTypes.map.isRequired,
  selection: ImmutablePropTypes.map,
  selections: ImmutablePropTypes.map,
  optionValueRestrictions: ImmutablePropTypes.map,
  openModal: PropTypes.func.isRequired,
  productType: PropTypes.string.isRequired,
  isStaffUser: PropTypes.bool.isRequired,
  userRole: PropTypes.string,
  id: PropTypes.string.isRequired,
  quantityCount: PropTypes.number.isRequired,
  selectedVariant: ImmutablePropTypes.map.isRequired,
};

export default OptionRow;
